import { createSelector } from 'reselect';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { IKnmErknmFormChangePlanReason } from '../interfaces/IKnmErknmFormChangePlanReason';

export const getKnmErknmInitialFormValues = (state: IRootState) => state.knmErknm.initialFormValues;
export const getKnmErknmFieldsForApproving = (state: IRootState) => state.knmErknm.fieldsForApproving;
export const getKnmIsShowMessageByStatus = (state: IRootState) => state.knmErknm.isShowMessageByStatus;
export const getKnmWasFirstInit = (state: IRootState) => state.knmErknm.wasFirstInit;
export const getKnmCreatedDate = (state: IRootState) => getKnmErknmInitialFormValues(state).created;
export const getKnmStartDate = (state: IRootState) => getKnmErknmInitialFormValues(state).startDate;
export const getKnmStopDate = (state: IRootState) => getKnmErknmInitialFormValues(state).stopDate;
export const getKnmIsApprovedOnPaper = (state: IRootState) => getKnmErknmInitialFormValues(state).isApprovedOnPaper;

export const getLatestKnmErknmChangePlanReason = (state: IRootState): IKnmErknmFormChangePlanReason | undefined => {
  const reasons = getKnmErknmInitialFormValues(state).changePlanReason;

  if (!reasons || reasons.length === 0) {
    return undefined;
  }

  return reasons.reduce((latest, current) => {
    if (!latest.dateCreate) return current;
    if (!current.dateCreate) return latest;

    return new Date(current.dateCreate) > new Date(latest.dateCreate) ? current : latest;
  });
};

export const getChecklistsPlanChanges = (state: IRootState) =>
  state.knm.rawData?.knmErknm?.changePlanChanges?.checklists ?? [];

export const getLatestKnmErknmChangePlanReasonTypeCode = createSelector(
  getLatestKnmErknmChangePlanReason,
  reason => reason?.reasonChangeType?.code,
);
export const getLatestKnmErknmChangePlanReasonApproveType = createSelector(
  getLatestKnmErknmChangePlanReason,
  reason => reason?.approvedChangePlanErknm?.id,
);
export const getRequirementsPlanChanges = (state: IRootState) =>
  state.knm.rawData?.knmErknm?.changePlanChanges?.requirementsNew ?? [];

export const getRequirementsNew = (state: IRootState) => state.knm.rawData?.knmErknm?.requirementsNew ?? [];

export const getKnmErknmIsPrescriptionOldRules = (state: IRootState): boolean | undefined =>
  state.knmErknm.isPrescriptionCheckByOldRules;

export const getKnmErknmIsPrescriptionFailed = (state: IRootState): boolean | undefined =>
  state.knmErknm.isPassportByCheckPrescriptionFailed;
